import React from 'react'
import { Modal, Button } from 'react-bootstrap'

export default class ConfirmScanModal extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.state = {}
  }

  handleShow() {
    this.setState({ show: true })
  }

  handleHide() {
    this.setState({ show: false })
  }

  render() {
    return (
      <div>
        <Button bsStyle="primary" className='delete-entry action-btn' onClick={this.handleShow}></Button>
        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.handleHide}
          dialogClassName="custom-modal"
          backdrop={false}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
              Voltooien scan
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Wilt u de scan voltooien?</p>
            <p>Nadat u de scan heeft voltooid, kunt u de resultaten van de scan bekijken. U kunt de gegeven antwoorden niet meer wijzigen.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.props.completeScan}>Voltooien</Button>
            <Button onClick={this.handleHide}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Scan/modal/index.js